"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgFireProtectionOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.fire-protection_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "fire-protection_outline_svg__transparent_box" },
            React.createElement("path", { className: "fire-protection_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "fire-protection_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "fire-protection_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M19.44 17.68a16.1 16.1 0 01-2.5-4l-.52-1.46-1.12 1.06c-.25.25-6.3 6.18-6.3 11.18A6.79 6.79 0 0016 31a6.79 6.79 0 007-6.54c0-2.87-1.54-4.55-2.78-5.9-.22-.3-.54-.56-.78-.88zM14 27.23c0-1.1 1.06-2.67 2-3.78.87 1 2 2.52 2 3.78A1.83 1.83 0 0116.41 29h-.82A1.83 1.83 0 0114 27.23zm6-.07c-.05-2.79-3-5.58-3.32-5.89l-.7-.65-.68.66c-.33.33-3.25 3.23-3.3 5.88a4.24 4.24 0 01-1-2.7c0-3.08 3.1-6.92 4.72-8.72a21.55 21.55 0 002.17 3.2c.26.32.55.64.85 1C19.9 21.17 21 22.37 21 24.46a4.24 4.24 0 01-1 2.7z" }),
            React.createElement("circle", { cx: 10, cy: 8, r: 1 }),
            React.createElement("circle", { cx: 22, cy: 8, r: 1 }),
            React.createElement("circle", { cx: 14, cy: 8, r: 1 }),
            React.createElement("circle", { cx: 18, cy: 8, r: 1 }),
            React.createElement("circle", { cx: 11, cy: 12, r: 1 }),
            React.createElement("circle", { cx: 21, cy: 12, r: 1 }),
            React.createElement("circle", { cx: 23, cy: 16, r: 1 }),
            React.createElement("circle", { cx: 9, cy: 16, r: 1 }),
            React.createElement("circle", { cx: 7, cy: 12, r: 1 }),
            React.createElement("circle", { cx: 25, cy: 12, r: 1 }),
            React.createElement("circle", { cx: 5, cy: 16, r: 1 }),
            React.createElement("circle", { cx: 27, cy: 16, r: 1 }),
            React.createElement("path", { d: "M19 3h-2V1h-2v2h-2v2h6V3z" }))));
}
exports.default = SvgFireProtectionOutline;
//# sourceMappingURL=FireProtectionOutline.js.map